import { TeamDashboardAPI } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import {
  TeamDashboardQueryResponse,
  SubmitTeamDashboardQueryPayload
} from './team-dashboard.types';

export const useSubmitTeamDashboardQuery = (
  config?: UseMutationOptions<
    TeamDashboardQueryResponse,
    unknown,
    SubmitTeamDashboardQueryPayload,
    unknown
  >
) => {
  return useMutation(TeamDashboardAPI.submitTeamDashboardQuery, { ...config });
};
